const initialData = {
  showShoutoutRequestToast: false
};

const shoutoutRequest = (state = initialData, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'SHOUTOUT_REQUEST':
      return {
        ...state,
        showShoutoutRequestToast: payload.showtoast
      };
    default:
      return state;
  }
};

export default shoutoutRequest;
